import { sanitizeAuth0User, type Auth0UserResponse } from '@/plugins/launchDarkly/utils';
import store from '@/store';
import { AuthIdentityConsistencyStatus, syncAuthIdentity } from '@/utils/authIdentityConsistency';

function getAuth0Permissions(auth0User: Auth0UserResponse): string[] {
  const permissions = auth0User['https://vaultn.io/permissions'];

  return Array.isArray(permissions) && permissions.every((permission) => typeof permission === 'string')
    ? permissions
    : [];
}

export function clearLegacyAuthState(): void {
  store.commit('clearLocalAuthState');
}

export function rebuildLegacyAuthStateFromAuth0(auth0User: Auth0UserResponse, accessToken: string): boolean {
  const authIdentityResult = syncAuthIdentity({
    auth0Subject: auth0User.sub,
    isAuthenticated: true,
  });

  if (authIdentityResult.status === AuthIdentityConsistencyStatus.InvalidIdentity) {
    clearLegacyAuthState();
    return false;
  }

  if (authIdentityResult.shouldClearLocalState) {
    clearLegacyAuthState();
  }

  store.commit('rebuildAuth0AuthState', {
    accessToken,
    auth0User: sanitizeAuth0User(auth0User),
    permissions: getAuth0Permissions(auth0User),
    userEmail: auth0User.email,
    userName: auth0User.name || auth0User.nickname,
  });
  return true;
}
